export default __webpack_public_path__ + "static/media/Signup-page2.990248ce.png";